

































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { JobDetail } from '@/@types/LibraryComponent';
import OrganizationIconTooltip from '@/components/common/OrganizationIconTooltip.vue';
import OrganizationNameTooltip from '@/components/common/OrganizationNameTooltip.vue';

@Component({
  components: {
    OrganizationIconTooltip,
    OrganizationNameTooltip,
  },
})
export default class ApplicationForm extends Vue {
  @Prop()
  private job!: JobDetail;
  private desiredConditionIsOpen: boolean = false;
  // TODO: 削除する
  private desiredPrice: number = 80;
  private desiredShift: Array<string> = [
    '平日',
    '休日',
    '2日以下',
    '3日',
    '4日',
    '5日',
    '日勤',
    '夜勤',
    '6時間/日未満',
  ];
  private contact: string =
    'はじめまして。ほにゃららと申します。ほにゃららについて確認させてください。よろしくお願いいたします。';
  private companyname: string = '株式会社ヒプスター';
  private companydetail: string =
    '株式会社ヒプスター \n東京都渋谷区道玄坂1-16−15\n道玄坂NKビル2F\n代表取締役 大石賢司';
  private openDesiredCondition() {
    this.desiredConditionIsOpen = !this.desiredConditionIsOpen;
  }
  @Emit('bookmark')
  private bookmark(): string {
    return '';
  }
}
